<dialog id="myModal" class="modal">
    <div class="modal-box bg-black text-white p-0.5 max-w-5xl">
        <form method="dialog">
            <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
        </form>
        <div class="w-full">
            <img [src]="activePromotion?.url" alt="promoImage" class="w-full h-auto object-cover rounded-md" />
        </div>
    </div>
</dialog>